import { ROOT_NODE } from "@craftjs/core";
import {
  setEndOfContenteditable,
  setEndOfContenteditableInsideTextNode,
} from "../helpers/richtext/caret-position";
import $ from "jquery";

function selectPreviousAfterDelete(actions, query, id, editorDocument) {
  // If query and actions are not available, return
  if (!query || !actions) {
    return;
  }

  // Get the currently selected node
  id = id ?? query.getEvent("selected").first();

  if (!id) return; // If no node is selected, return

  var $lastDom = $(
    editorDocument.querySelectorAll(`[data-grigora-block="true"]`),
  );
  var $next, $prev;
  if ($lastDom) {
    $next = $lastDom.eq(
      $lastDom.index(
        $(editorDocument.querySelector(`[data-grigora-block-id="${id}"]`)),
      ) + 1,
    );
    $prev = $lastDom.eq(
      $lastDom.index(
        $(editorDocument.querySelector(`[data-grigora-block-id="${id}"]`)),
      ) - 1,
    );

    // Filter our ROOT Node from $prev
    if ($prev.attr("data-grigora-block-id") === ROOT_NODE) {
      $prev = [];
    }
  }

  if ($prev.length > 0) {
    // Focus on previous element
    var prevID = $prev.attr("data-grigora-block-id");
    actions.selectNode(prevID);

    // If node is richtext then focus on it
    if ($prev.find(".grigora-richtext-input__field").length > 0) {
      setEndOfContenteditableInsideTextNode(
        editorDocument,
        $prev.find(".grigora-richtext-input__field").last()[0],
      );
    }
  } else if ($next.length > 0) {
    // Focus on next element
    var nextID = $next.attr("data-grigora-block-id");
    actions.selectNode(nextID);
    // If node is richtext then focus on it
    if ($next.find(".grigora-richtext-input__field").length > 0) {
      $next.find(".grigora-richtext-input__field")[0].focus();
    }
  }
}

export default selectPreviousAfterDelete;
